const environment = {
    TIM2: window.location.href.indexOf("TIM2") !== -1
};

export default environment;